import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Box, CircularProgress, Typography } from "@material-ui/core"

function CircularProgressWithLabel(props) {
	return (
		<Box sx={{ position: "relative", display: "inline-flex" }}>
			<CircularProgress variant="determinate" {...props} />
			<Box
				sx={{
					top: 0,
					left: 0,
					bottom: 0,
					right: 0,
					position: "absolute",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
				}}
			>
				<Typography variant="caption" component="div" color="text.secondary">
					{`${Math.round(props.value)}%`}
				</Typography>
			</Box>
		</Box>
	)
}

CircularProgressWithLabel.propTypes = {
	/**
	 * The value of the progress indicator for the determinate variant.
	 * Value between 0 and 100.
	 * @default 0
	 */
	value: PropTypes.number.isRequired,
}

function PercentagePie({ assignmentDeatils, isAssigmentDone, setIsAssignmentDone, isEqualAssignment, autoAssignment }) {
	const [progress, setProgress] = useState(0)

	useEffect(() => {
		let assignmentProgress = 0
		assignmentDeatils?.userRow?.map((item, idx) => {
			if (item?.percentage && item?.assignTo) {
				assignmentProgress = assignmentProgress + parseInt(item?.percentage)
			}
		})

		if (assignmentProgress <= 100) {
			setProgress(assignmentProgress)
		} else {
			setIsAssignmentDone(false)
		}
	}, [assignmentDeatils?.userRow])

	useEffect(() => {
		if (progress === 100) {
			setIsAssignmentDone(true)
		} else {
			setIsAssignmentDone(false)
		}
	}, [progress])

	useEffect(() => {
		autoAssignment && setProgress(0)
	}, [autoAssignment])

	return !isEqualAssignment && <CircularProgressWithLabel value={progress} />
}

export default PercentagePie
